export default function validateInfo(walletAddress) {
  let error = "";

  if (!walletAddress) {
    error = "Wallet Address required";
  } else if (!/^(EQ|UQ)[A-Za-z0-9_-]{46}$/.test(walletAddress)) {
    error = "Wallet Address is invalid";
  }
  return error;
}
